
import { dateHelper } from '@/helpers/dateHelper'
import { ClientPage, Collect } from '@/types'
import Vue from 'vue'

const defaultBody = {
  informations: '',
  showInterval: false,
  title: '',
  instructions: [] as Array<{ rank: number; title: string }>,
}

export default Vue.extend({
  name: 'mp-drive-validation',
  props: {
    collect: {
      type: Object as () => Collect,
      required: true,
    },
    clientPage: {
      type: Object as () => ClientPage,
      required: true,
    },
  },
  data() {
    return {
      body: defaultBody,
      dateHelper,
    }
  },
  mounted() {
    this.body = { ...defaultBody, ...this.clientPage.config.body }
    this.body.instructions = this.body.instructions.sort((a, b) => a.rank - b.rank)
  },
  watch: {
    clientPage: {
      deep: true,
      handler(next) {
        this.body = JSON.parse(JSON.stringify({ ...defaultBody, ...next.config.body }))
        this.body.instructions = this.body.instructions.sort((a, b) => a.rank - b.rank)
      },
    },
  },
})
